/**
 * A row of the "Link data" step: one Luminary entity, and the integration
 * entities currently attached to it.
 *
 * Both link panes normalize their very different queries down to this shape so
 * they can share a table, a form, and a save.
 */
export interface EntityLinkRow {
  id: string;
  displayName: string;
  /** Current value, already formatted for display. Null when unavailable. */
  formattedValue: string | null;
  /** Owners, grantors or donors, by display name. Empty when the kind has none. */
  ownerNames: string[];
  /** Human-readable entity kind, e.g. "Revocable trust". */
  typeLabel: string;
  /** IDs of the integration entities currently linked to this entity. */
  integrationEntityIds: string[];
}

export interface EntityLinkFormEntity {
  integrationEntities: string[];
  includeAllEntities: boolean;
}

/** Form state for a link pane, keyed by Luminary entity ID. */
export interface EntityLinkFormShape {
  entities: Record<string, EntityLinkFormEntity>;
}

/** Builds the pane's initial form state from its normalized rows. */
export function buildEntityLinkFormValues(
  rows: EntityLinkRow[]
): EntityLinkFormShape {
  return {
    entities: Object.fromEntries(
      rows.map((row) => [
        row.id,
        {
          integrationEntities: row.integrationEntityIds,
          includeAllEntities: false,
        },
      ])
    ),
  };
}
